import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { baseUrl } from "../../../shared/Fetch";

export interface IConsSubmission {
    consultant_id?: number,
    consultant_Email_ID?: string,
    req_id?: number,
    vendor_Company_Name?: string,
    recruiterName?: string,
    salManagerName?: string,
    buyingRate?: string,
    submittal_Rate?: string,
    submital_Date?: Date,
    faceToFaceInterview?: string,
    totalExp?: number,
    relivantExp?: number,
    usExp?: number,
    submissionType?: string,
    salary?: string,
    tax_Term?: string,
    resume_Path?: string,
    openModelStatus?:boolean
}

interface Iprops {
    data: Array<IConsSubmission>
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const SubmissionsTable = (props: Iprops) => {
    const onHide = () => {
        props.hideDialog();
    }
    const pDate = (rowData: IConsSubmission) => {
        let date;
        if (rowData.submital_Date) date = format(new Date(rowData.submital_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const downloadResume = async (path: string, consultant_email_id: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${path}&consultant_email_id=${consultant_email_id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${consultant_email_id}.docx`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const download = (rowData: IConsSubmission) => {
        return (
            <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => { if (rowData.resume_Path && rowData.consultant_Email_ID) downloadResume(rowData.resume_Path, rowData.consultant_Email_ID); }} />
        );
    };
//`Submissions for Consultant to "${props.data[0]?.vendor_Company_Name}"`
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`Submissions for Consultant`} className="p-fluid" draggable={false} onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={props.data}
            >
                <Column field="req_id" header="Req ID" />
                <Column field="salManagerName" header="Sales Manager" />
                <Column field="recruiterName" header="Recruiter" />
                <Column field="buyingRate" header="Buying Rate" />
                <Column field="submittal_Rate" header="Submittal Rate" />
                <Column field="submital_Date" header="Submission Date" body={pDate} />
                <Column header="Download" body={download} />
            </DataTable>
        </Dialog>
    );
}